export const isPartEligibleForWarranty = (part) =>
  String(part.rmaFormViewable).toLowerCase() === 'yes';
